import {PageBase} from "@/app2/shared/layouts/PageBase";
import {makeStyles} from "tss-react/mui";
import {Box} from "@mui/material";
import {PageTitle} from "@/app2/shared/components/pageTitle";
import {useSSTranslation} from "@/i18n/useSSTranslation";
import HomeContent from "@/app2/pages/HomePage/HomeContent";
import App2AnnouncementsSection from "@/app2/pages/HomePage/AnnouncementsSection/App2AnnouncementsSection";
import useDevCycleSdk from "@/app2/shared/hooks/useDevCycleSdk";
import {useGetLearnerAssignedAnnouncements, useCompleteAnnouncement} from "@/app2/shared/data";
import {useContext, useEffect} from "react";
import {PageBaseContext} from "@/contexts/pageBaseContext";

const useStyles = makeStyles()(() => ({
	pageBase: {
		"& [class*='menuIcon']": {
			display: "none"
		}
	},
	tapToLoadBtn: {},
	container:{
		padding: "15px"

	}
}));


export const HomePage: React.FC = () => {
	const {classes} = useStyles();
	const {announcements} = useDevCycleSdk();
	const {t} = useSSTranslation();
	const {data: announcementsData, isLoading: announcementsLoading} = useGetLearnerAssignedAnnouncements(undefined, { enabled: announcements === true });
	const completeAnnouncement = useCompleteAnnouncement();
	const announcementList = announcementsData?.data ?? [];
	const hasAnnouncements = announcementList.length > 0;

	const [, setPageBaseContext] = useContext(PageBaseContext);
	useEffect(() => {
		if (announcements && announcementList.length > 0) {
			setPageBaseContext(prev => ({
				...prev,
				notificationCount: (prev?.notificationCount ?? 0) + announcementList.length
			}));
		}
	}, [announcements, announcementList.length, setPageBaseContext]);

	return (
		<PageBase
			className={classes.pageBase}
			disableSideBar
			contentWidth="1420px"
			data-test-id="home-page"
		>
			{announcements && hasAnnouncements && !announcementsLoading && (
				<Box sx={{margin: "15px", marginBottom: 0}}>
					<App2AnnouncementsSection
						announcementsData={announcementList}
						onComplete={(slug) => completeAnnouncement.mutate(slug)}
					/>
				</Box>
			)}
			<PageTitle
				sx={{margin: "0 0 0 20px"}}
				enableDayStreak
				applyNewTitleStyle={true}
				title={t("page_home", "Home")}
				data-test-id="home-page-title"
			/>
			<Box
				className={classes.container}
				data-test-id="home-content-container"
				role="main"
				aria-label="Home content"
			>
				<HomeContent/>
			</Box>
		</PageBase>
	);
}